const config = require('./config.json');
const collection = require('./ors-de-france');

if (!config.routes) config.routes = [];
config.routes = config.routes.concat(collection);

module.exports = config;
